export const LOAD_SELECTED_COMMUNITY_CATEGORY_DATA = "LOAD_SELECTED_COMMUNITY_CATEGORY_DATA";
export const LOAD_SELECTED_BLOG_DATA = "LOAD_SELECTED_BLOG_DATA";

//Action Creator
export const setCommunityCategoryItem = (data) => {
    return { type: LOAD_SELECTED_COMMUNITY_CATEGORY_DATA, data }
}

export const setCommunityBlogItem = (data) => {
    return { type: LOAD_SELECTED_BLOG_DATA, data }
}

